import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogSlopedSites() {
  useEffect(() => {
    document.title = 'Formwork Strategies for Sloped Sites: Lessons from North Vancouver and Tri-Cities | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Building on a hill requires more than just a standard plan. Learn hillside formwork strategies and how AutoCAD site plans account for elevation changes typical in North Shore and Coquitlam construction projects.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'hillside formwork design, sloped site construction BC, North Vancouver construction layout, AutoCAD site planning, elevation changes formwork');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Formwork Strategies for Sloped Sites: Lessons from North Vancouver and the Tri-Cities',
      description: 'Building on a hill requires more than just a standard plan. Learn hillside formwork strategies and how AutoCAD site plans account for elevation changes.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2024-04-10',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-sloped"]')) {
      script.setAttribute('data-schema', 'blog-sloped');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-sloped"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
